import { PaletteOptions } from '@mui/material/styles';

export const palette: PaletteOptions = {
  primary: {
    main: '#137D38',
    light: '#19AA4E',
    dark: '#0D5527',
  },
  success: {
    main: '#137D38',
    light: '#E4FBEC',
    dark: '#0D5527',
  },
  error: {
    main: '#E31B0C',
    light: '#FDECEA',
    dark: '#FFCFD6',
  },
  warning: {
    main: '#C77700',
  },
  info: {
    main: '#000',
  },
  primaryButton: {
    main: '#24DE67',
    dark: '#1EC65B',
    contrastText: '#003615',
  },
  navigation: {
    main: '#00593E',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#F9F4EE',
  },
  highlight: {
    main: '#FFE278',
    contrastText: '#000000',
    dark: '#ffb547',
  },
  // Neutral greys by use, in place of MUI's numbered `grey` scale.
  neutral: {
    subtle: '#FAFAFA',
    fill: '#EEEEEE',
    fillHover: '#E0E0E0',
    main: '#9E9E9E',
    dark: '#616161',
  },
  text: {
    primary: '#000000',
    secondary: '#404040',
  },
};
